import { motion } from "framer-motion";
import { SERVICES } from "../../lib/data";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Services = () => {
  return (
    <section id="services" className="py-20 sm:py-28 px-6 sm:px-10 lg:px-14 bg-paper">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="text-center mb-14 max-w-3xl mx-auto"
        >
          <motion.p variants={fadeUp} custom={0} className="eyebrow mb-3">
            What We Treat
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            className="font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight"
          >
            Comprehensive Urological Services in Chennai
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={2}
            className="mt-4 text-base sm:text-lg text-ink-soft"
          >
            Expert urological treatment for kidney stones, prostate, male fertility, urological cancers &amp; kidney transplantation — delivered with advanced robotic and laser technology.
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`service-card-${i}`}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-50px" }}
              variants={fadeUp}
              className="group card-hover bg-bone-2 border border-line rounded-2xl p-7 flex flex-col"
            >
              <h3 className="font-sans font-bold text-lg text-ink leading-snug">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-ink-soft leading-relaxed">
                {s.desc}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
